import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AcEnvelopeGraph } from './AcEnvelopeGraph';
import { AcEnvelopeMeta } from './AcEnvelopeMeta';
import { AcEnvelopeTable } from './AcEnvelopeTable';
export function AcEnvelope(props) {
    const totalSegments = props.totalSegments ?? 8;
    const maxTime = props.maxTime ?? 127;
    const maxLevel = props.maxLevel ?? 127;
    const endSegment = clampSegment(props.endSegment, totalSegments);
    const sustainSegment = clampSegment(props.sustainSegment, endSegment);
    const activeSegment = clampSegment(props.activeSegment, endSegment);
    const segments = props.segments.slice(0, endSegment);
    const rootClass = props.className ? `ac-envelope ${props.className}` : 'ac-envelope';
    const disabled = props.disabled === true;
    return (_jsxs("div", { className: rootClass, "data-disabled": disabled ? 'true' : undefined, children: [_jsx(AcEnvelopeGraph, { label: props.label, segments: segments, maxTime: maxTime, maxLevel: maxLevel, sustainSegment: sustainSegment, activeSegment: activeSegment, helpText: props.helpText, onPointSelect: props.onPointSelect, onTimeChange: props.onTimeChange, onLevelChange: props.onLevelChange, onCommit: props.onCommit, onExpand: props.onExpand, disabled: disabled }), _jsx(AcEnvelopeMeta, { totalSegments: totalSegments, sustainSegment: sustainSegment, endSegment: endSegment, onSustainChange: props.onSustainChange, onEndChange: props.onEndChange, disabled: disabled }), _jsx(AcEnvelopeTable, { segments: segments, maxTime: maxTime, maxLevel: maxLevel, activeSegment: activeSegment, sustainSegment: sustainSegment, onPointSelect: props.onPointSelect, onTimeChange: props.onTimeChange, onLevelChange: props.onLevelChange, disabled: disabled })] }));
}
function clampSegment(value, ceiling) {
    if (!Number.isFinite(value)) {
        throw new Error(`AcEnvelope received non-finite segment index: ${value}`);
    }
    if (value < 1) {
        return 1;
    }
    if (value > ceiling) {
        return ceiling;
    }
    return Math.floor(value);
}
//# sourceMappingURL=AcEnvelope.js.map